import { createContext, ReactNode, useEffect, useState } from "react";
import { debounce } from "lodash";
import { breakpoints } from "../theme/breakpoints";

export interface ScreenSize {
  desktop: boolean;
  tablet: boolean;
  mobile: boolean;
  width: number;
  height: number;
}

export const ScreenSizeContext = createContext<ScreenSize>({
  desktop: false,
  tablet: false,
  mobile: false,
  width: 0,
  height: 0,
});

interface Props {
  children?: ReactNode;
}

export default function ScreenSizeProvider({ children }: Props) {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setInnerWidth(window.innerWidth);
      setInnerHeight(window.innerHeight);
    }
    // Add event listener
    window.addEventListener("resize", debounce(handleResize, 200));
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Empty array ensures that effect is only run on mount
  return (
    <ScreenSizeContext.Provider
      value={{
        desktop: innerWidth >= breakpoints.desktop,
        tablet:
          innerWidth < breakpoints.desktop && innerWidth > breakpoints.tablet,
        mobile: innerWidth <= breakpoints.tablet,
        width: innerWidth,
        height: innerHeight,
      }}
    >
      {children}
    </ScreenSizeContext.Provider>
  );
}
